import React from "react"
import { Box } from "@mui/material"
import PropTypes from "prop-types"

const LoaderOverlay = ({ children }) => (
    <Box
        position="fixed"
        top={0}
        left={0}
        width="100vw"
        height="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
            backgroundColor: "transparent",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            zIndex: 99999,
        }}
    >
        {children}
    </Box>
)

LoaderOverlay.propTypes = {
    children: PropTypes.node.isRequired,
}

export default LoaderOverlay
